import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import FormControl from '@mui/material/FormControl';
import { StyledDataGrid } from "./StyledDataGrid";
import Course from "./Course";
import { pdf } from "@react-pdf/renderer";
import Forcardlist from "./Document/Forcardlist";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import StudentListR from "./Document/StudentListR";
import BatchWiseReports from "./Document/BatchWiseReports";
import YearlyReport from "./Document/YearlyReport";
import Documents from "./Document/Documents";
import CancelledStudents from "./Document/CancelledStudents";
import DatePicker from "react-datepicker";
import MonthWiseReport from "./Document/MonthWiseReport";
import PlacedStudents from "./Document/PlacedStudents";
const StudentReport = () => {


    const [error, setError] = useState({})
    const [course, setCourse] = useState([])
    const [batch, setBatch] = useState([]);
    const [Category, setCat] = useState("batch");



    const [value, setValue] = useState({
        course: "",
        batch: "",
        startdate: "",
        enddate: '',
        month: '',
        year: ''
    })




    const validateForm = () => {
        let isValid = true
        const newErrors = {}


        if (Category === 'month') {
            // In 'month' category, course is required only if month/year are missing
            if (!value.course && (!value.month || !value.year)) {
                isValid = false;
                newErrors.course = "Course is Required";
            }
        } else {
            // In other categories, course is not required if both startdate and enddate are selected
            if (!value.course && (!value.startdate || !value.enddate)) {
                isValid = false;
                newErrors.course = "Course is Required";
            }
        }


        if (
            !value.batch &&
            Category !== 'month' &&
            Category !== 'yearly' &&
            Category !== 'placed' &&
            (!value.startdate || !value.enddate)
        ) {
            isValid = false;
            newErrors.batch = "Batch is Required";
        }




        if (
            (Category === 'cancelled' || Category === 'yearly' || Category === 'placed') &&
            !value.course
        ) {
            if (!value.startdate) {
                isValid = false;
                newErrors.startdate = "Start Date is Required";
            }
            if (!value.enddate) {
                isValid = false;
                newErrors.enddate = "End Date is Required";
            }
        }


        if (Category === 'month') {
            // If course is not selected, then month and year are required
            if (!value.course) {
                if (!value.month) {
                    isValid = false;
                    newErrors.month = "Month is Required";
                }
                if (!value.year) {
                    isValid = false;
                    newErrors.year = "Year is Required";
                }
            }
        }







        setError(newErrors)
        return isValid


    }

    async function getCourseData() {
        axios
            .get(`${BASE_URL}/getCourse`)
            .then((res) => {
                setCourse(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    useEffect(() => {
        getCourseData();
        value.title = "";
        setError({});
    }, []);




    const handleSubmit = (e) => {
        e.preventDefault()

        if (validateForm()) {
            generatePdf();

        }
    };

    const generatePdf = () => {
        switch (Category) {
            case "forcard":
                forcardlistpdf();
                break;
            case "student":
                StudentListRpdf();
                break;
            case "batch":
                BatchWiseReportspdf();
                break;
            case "yearly":
                Yearlypdf();
                break;
            case "document":
                Documentypdf();
                break;
            case "cancelled":
                CancelledStudentpdf();
                break;
            case "month":
                MonthWiseReportpdf()
                break;
            case "placed":
                PlacedStudentpdf()
            default:
                console.warn("Unknown category:", Category);
        }
    };




    const handlegetbatch = async (courseid) => {
        setValue({
            course: courseid,
        });

        try {
            const res = await axios.post(`${BASE_URL}/getcoursewisebatch`, { courseid: courseid });


            setBatch(res.data);
        } catch (err) {
            console.error("Error fetching data:", err);
        }
    };

    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }




    const roledata = {
        role: Cookies.get(`role`),
        pageid: 47,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);


    const forcardlistpdf = async () => {
        const res = await axios.post(`${BASE_URL}/getforcardlist`, { batch_code: value.batch, course_id: value.course });
        const blob = await pdf(<Forcardlist data={res.data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);

    };
    const StudentListRpdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getStudentListReport`, { batch_code: value.batch });
            if (!res.data || !res.data || res.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }
            const blob = await pdf(<StudentListR data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);
        } catch {
            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };

    const BatchWiseReportspdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getidStudent`, { batch_code: value.batch });
            if (!res.data || !res.data || res.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }
            const blob = await pdf(<BatchWiseReports data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);
        } catch {
            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };

    const Yearlypdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getstudentyearly`, { course: value.course, startdate: value.startdate, enddate: value.enddate });
            if (!res.data || !res.data.data || res.data.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }
            const blob = await pdf(<YearlyReport data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);
        } catch {
            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };
    const Documentypdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getidStudent`, { batch_code: value.batch });
            if (!res.data || !res.data.data || res.data.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }
            const blob = await pdf(<Documents cardlist={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);
        } catch {
            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };

    const CancelledStudentpdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getcancelledstudent`, { course: value.course, batch_code: value.batch, startdate: value.startdate, enddate: value.enddate });

            if (!res.data || !res.data.data || res.data.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }

            const blob = await pdf(<CancelledStudents data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);
        } catch {
            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };

    const MonthWiseReportpdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getmonthwise`, { course: value.course, month: value.month, year: value.year });

            if (!res.data || !res.data.data || res.data.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }
            const blob = await pdf(<MonthWiseReport data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);
        } catch {
            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };
    const PlacedStudentpdf = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/getplacedstudent`, { course: value.course, startdate: value.startdate, enddate: value.enddate });

            if (!res.data || !res.data.data || res.data.data.length === 0) {
                alert("No data found for the selected filters.");
                return;
            }
            const blob = await pdf(<PlacedStudents data={res.data} />).toBlob();
            const url = URL.createObjectURL(blob);
            window.open(url);
            URL.revokeObjectURL(url);

        } catch {

            console.error("Error generating PDF:", error);
            alert("An error occurred while generating the PDF.");
        }


    };


    const handleCategoryChange = (event) => {
        setValue((prev) => ({
            ...prev,
            course: "",
            batch: "",
            startdate: "",
            enddate: "",
            month: "",
            year: ""
        }));

        setCat(event.target.value);
    };



    return (

        <div class="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Student Report</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3" onSubmit={handleSubmit}>
                                        <div class='row'>

                                            <div class="from-group col-lg-12">
                                                <FormControl>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        value={Category} // bind the selected value
                                                        name="row-radio-buttons-group"
                                                        onChange={handleCategoryChange} // centralized handler
                                                    >
                                                        <FormControlLabel value="student" control={<Radio />} label="Student List" />
                                                        <FormControlLabel value="batch" control={<Radio />} label="Batch Wise" />
                                                        <FormControlLabel value="yearly" control={<Radio />} label="Yearly" />
                                                        <FormControlLabel value="forcard" control={<Radio />} label="For Card List" />
                                                        <FormControlLabel value="month" control={<Radio />} label="Month Wise" />
                                                        <FormControlLabel value="document" control={<Radio />} label="Documents" />
                                                        <FormControlLabel value="left" control={<Radio />} label="Left" />
                                                        <FormControlLabel value="cancelled" control={<Radio />} label="Cancelled Students" />
                                                        <FormControlLabel value="placed" control={<Radio />} label="Placed Students" />


                                                    </RadioGroup>
                                                </FormControl>

                                            </div>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1"
                                                    onChange={(e) => handlegetbatch(e.target.value)}
                                                    name="course" value={value.course}>
                                                    <option value="">Select</option>
                                                    {course.map((courses) => {
                                                        return (
                                                            <option value={courses.Course_Id} >
                                                                {courses.Course_Name}
                                                            </option>
                                                        );
                                                    })}

                                                </select>
                                                {<span className="text-danger"> {error.course} </span>}
                                            </div>


                                            {(Category == 'student' || Category == 'batch' || Category == 'forcard' || Category == 'document' || Category == 'left' || Category == 'cancelled') && <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Batch<span className='text-danger'>*</span> </label>
                                                <select
                                                    class="form-control form-control-lg"
                                                    id="exampleFormControlSelect1"
                                                    onChange={onhandleChange}
                                                    name="batch"
                                                    value={value.batch}
                                                >
                                                    <option>Select Batch</option>

                                                    {batch.map((item) => {
                                                        return (
                                                            <option value={item.Batch_code}>{item.Batch_code}</option>
                                                        );
                                                    })}
                                                </select>
                                                {<span className="text-danger"> {error.batch} </span>}
                                            </div>}


                                            {Category == 'month' &&
                                                <div class="form-group col-lg-4">
                                                    <label for="exampleFormControlSelect1">Select Month<span className='text-danger'>*</span> </label>
                                                    <select
                                                        class="form-control form-control-lg"
                                                        id="exampleFormControlSelect1"
                                                        onChange={onhandleChange}
                                                        value={value.month}
                                                        name="month"
                                                    >
                                                        <option>Select Month</option>
                                                        <option value="1">January</option>
                                                        <option value="2">February</option>
                                                        <option value="3">March</option>
                                                        <option value="4">April</option>
                                                        <option value="5">May</option>
                                                        <option value="6">June</option>
                                                        <option value="7">July</option>
                                                        <option value="8">August</option>
                                                        <option value="9">September</option>
                                                        <option value="10">October</option>
                                                        <option value="11">November</option>
                                                        <option value="12">December</option>
                                                    </select>
                                                    {<span className="text-danger"> {error.month} </span>}
                                                </div>
                                            }

                                            {Category == 'month' && <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Year<span className='text-danger'>*</span> </label>
                                                <select
                                                    class="form-control form-control-lg"
                                                    id="exampleFormControlSelect1"
                                                    onChange={onhandleChange}
                                                    name="year"
                                                    value={value.year}
                                                >
                                                    <option>Select Year</option>
                                                    <option value="2000">2000 </option>
                                                    <option value="2001">2001</option>
                                                    <option value="2002">2002</option>
                                                    <option value="2003">2003</option>
                                                    <option value="2004">2004</option>
                                                    <option value="2005">2005</option>
                                                    <option value="2006">2006</option>
                                                    <option value="2007">2007</option>
                                                    <option value="2008">2008</option>
                                                    <option value="2009">2009</option>
                                                    <option value="2010">2010</option>
                                                    <option value="2011">2011</option>
                                                    <option value="2012">2012</option>
                                                    <option value="2013">2013</option>
                                                    <option value="2014">2014</option>
                                                    <option value="2015">2015</option>
                                                    <option value="2016">2016</option>
                                                    <option value="2017">2017</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>

                                                </select>
                                                {<span className="text-danger"> {error.year} </span>}
                                            </div>}

                                            {(Category == 'yearly' || Category == 'placed' || Category == 'cancelled') &&
                                                <div class="form-group col-lg-4">
                                                    <label style={{ display: "block" }}>Start Date<span className='text-danger'>*</span> </label>

                                                    <DatePicker
                                                        selected={value.startdate}
                                                        onChange={(date) => {
                                                            const formattedDate = date.toISOString().split('T')[0]; // yyyy-MM-dd
                                                            onhandleChange({
                                                                target: {
                                                                    name: 'startdate',
                                                                    value: formattedDate
                                                                }
                                                            });
                                                        }}

                                                        className="form-control"
                                                        id="exampleInputUsername1"
                                                        dateFormat="yyyy-MM-dd"
                                                        placeholderText="Select Date"
                                                    />

                                                    {<span className="text-danger"> {error.startdate} </span>}
                                                </div>
                                            }

                                            {(Category == 'yearly' || Category == 'placed' || Category == 'cancelled') &&
                                                <div class="form-group col-lg-4">
                                                    <label style={{ display: "block" }}>End Date<span className='text-danger'>*</span> </label>
                                                    <DatePicker
                                                        selected={value.enddate}
                                                        onChange={(date) => {
                                                            const formattedDate = date.toISOString().split('T')[0]; // yyyy-MM-dd
                                                            onhandleChange({
                                                                target: {
                                                                    name: 'enddate',
                                                                    value: formattedDate
                                                                }
                                                            });
                                                        }}
                                                        className="form-control"
                                                        id="exampleInputUsername1"
                                                        dateFormat="yyyy-MM-dd"
                                                        placeholderText="Select Date"
                                                    />
                                                    {<span className="text-danger"> {error.enddate} </span>}
                                                </div>
                                            }


                                        </div>




                                        <button
                                            type="submit"
                                            class="btn btn-primary mr-2"
                                        // onClick={() => downloadPDF(1)}
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                window.location.reload();
                                            }}
                                            class="btn btn-light"
                                        >
                                            Cancel
                                        </button>
                                    </form>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div >

    )
}

export default StudentReport
